import "../../../style/profileSettings/AddressInfo.css";
import Box from "@mui/material/Box";
import { useRecoilValue } from "recoil";
import { newHSCodesAnimationState } from "../../../atoms/membership";
import AddHSCodes from "./AddHSCodes";
import HSCodesList from "./HSCodesList";
import CreateHSCodes from "./CreateHSCodes";

const NewHSCodes = () => {
  const newHSCodesAnimation = useRecoilValue(newHSCodesAnimationState);

  return (
    <Box className="new-address">
      <>
        {newHSCodesAnimation === false && (
          <>
            <AddHSCodes />
            <HSCodesList />
          </>
        )}
        <CreateHSCodes />
      </>
    </Box>
  );
};

export default NewHSCodes;
